import React from 'react';
import { VisaLogo as BaseVisaLogo } from '@move-frontend/form';
import { useTranslationForType } from '../hooks/useTranslationForType';
import { CreditCardType } from '../../../domain/models';

export const VisaLogo = () => {
	const alt = useTranslationForType(CreditCardType.Mastercard);

	return <BaseVisaLogo alt={alt} />;
};
